"use client";

import { useEffect, useRef } from "react";

import { track } from "@/lib/analytics";

/**
 * Fires `academy_catalog_viewed` once when the Catalog is shown. Renders nothing.
 *
 * @returns Always null, since the component only tracks.
 */
export const TrackCatalogView = () => {
  const fired = useRef(false);
  useEffect(() => {
    if (!fired.current) {
      fired.current = true;
      track("academy_catalog_viewed", {});
    }
  }, []);

  return null;
};

/**
 * Fires `academy_course_viewed` once when a Course page is shown. Renders nothing.
 *
 * @param props - The component props.
 * - `courseSlug`: The public slug of the Course being shown.
 * @returns Always null, since the component only tracks.
 */
export const TrackCourseView = ({ courseSlug }: { courseSlug: string }) => {
  const fired = useRef(false);
  useEffect(() => {
    if (!fired.current) {
      fired.current = true;
      track("academy_course_viewed", { courseSlug });
    }
  }, [courseSlug]);

  return null;
};
